import { Data, TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  initialLoad(data: Data) {
    return {
      'Account Id': data.accountId,
      'Data Center': data.dataCenter,
      'Route Name': data.routeName,
      'Has Tried To Override Metric': data.hasTriedToOverrideMetric,
      'Journeys Loading Gears Display': data.journeysLoadingGearsDisplay ?? 0,
      'Journeys Loading Gears Hide': data.journeysLoadingGearsHide ?? 0,
      'Loading State End': data.loadingStateEnd ?? 0,
    };
  },
  signupDelay(data: Data) {
    return {
      'Account Id': data.accountId,
      'Data Center': data.dataCenter,
      'Go To Account Delay': data.goToAccountDelay,
      'Account Ready Duration': data.accountReadyDuration,
      'Signup Type': data.signupType,
    };
  },
};

export default Transforms;
